import { useStorage } from '../../context/storage-context';
import type { PathId } from '../../types/handlers/navigation';

export type CustomerGroupCreateMethod = 'quick' | 'advanced';

export const CUSTOMER_GROUP_CREATE_METHOD_PATH_IDS: Record<CustomerGroupCreateMethod, PathId> = {
  quick: 'customerGroup.quickSetup',
  advanced: 'customerGroup.create',
};

const CREATE_METHOD_STORAGE_KEY = 'customer-groups-create-method';

export function useLastCustomerGroupCreateMethod() {
  const [method, setMethod] = useStorage<CustomerGroupCreateMethod>(CREATE_METHOD_STORAGE_KEY);

  // Default to quick setup
  return [method === 'advanced' ? 'advanced' : 'quick', setMethod] as const;
}
